export default __webpack_public_path__ + "media/images/Masto-H1-geisha-f1bfa640bcfa2d4c1510a0aa1402b3e7.png";